<h5 mat-dialog-title>{{title}}</h5>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="flex-end center">
    <button mat-flat-button (click)="dialogRef.close(false)">Anulează</button>
    <button mat-flat-button color="warn" (click)="dialogRef.close(true)">Da</button>
</div>
